import { resolveAppData } from '@/logic/app-data';
import { isNativeApiAllowedRoute } from '@/logic/app-data/app-data-route';
import { getPageConfig } from '@/lib/aggregation';
import { getIsSiteWideJackpotEnabled } from '@/logic/page-config/static-page/static-page-utils';

export type FeatureFlagsResult = {
    featureFlags: Record<string, true>;
    isSiteWideJackpotEnabled: boolean;
};

export const getFeatureFlags = async ({ currentRoute }: { currentRoute: string }): Promise<FeatureFlagsResult> => {
    if (!isNativeApiAllowedRoute(currentRoute)) {
        const response = await getPageConfig(currentRoute);
        const featureFlags =
            response?.pageConfig?.product?.data?.features?.reduce(
                (flags, feature) => {
                    flags[feature.feature_name] = true;
                    return flags;
                },
                {} as Record<string, true>
            ) ?? {};

        return {
            featureFlags,
            isSiteWideJackpotEnabled: getIsSiteWideJackpotEnabled(response?.pageConfig?.product)
        };
    }

    const shell = (await resolveAppData(currentRoute))?.shell;
    const featureFlags = (shell?.productFeatures ?? []).reduce(
        (flags, featureName) => {
            flags[featureName] = true;
            return flags;
        },
        {} as Record<string, true>
    );

    return {
        featureFlags,
        isSiteWideJackpotEnabled: shell?.siteWideJackpot.enabled === true
    };
};
